import { z } from 'zod'

export const managerBenefitGetCompanyEmployeeMileageSchema = z.object({
  /** 哩程數 */
  mileage: z.number(),
  /** 上限哩程數 */
  maxMileage: z.number()
})

export interface ManagerBenefitGetCompanyEmployeeMileage
  extends z.infer<typeof managerBenefitGetCompanyEmployeeMileageSchema> {}

export class ManagerBenefitGetCompanyEmployeeMileage {
  constructor() {
    return {
      mileage: 0,
      maxMileage: 0
    }
  }
}
